import { render, staticRenderFns } from "./MsgDetails.vue?vue&type=template&id=4a37124c&scoped=true&"
import script from "./MsgDetails.vue?vue&type=script&lang=js&"
export * from "./MsgDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a37124c",
  null
  
)

export default component.exports